module.exports = __webpack_public_path__ + "img/five.f5c465da.png";